import { Button } from '@yes.technology/react-toolkit'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  width: 100%;
`

export const StyledSideMenu = styled.div`
  width: 330px;
  border-right: 1px solid #abbdd1;
  background-color: #f7f8fa;
  padding: 2rem;
  box-sizing: border-box;

  position: sticky;
  top: 0;
  height: 100vh;

  h2 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: #303032;
    margin-bottom: 1.5rem;
  }
`

export const StyledSitemodelView = styled.div`
  flex: 1;
  padding: 1rem 2rem 0 1rem;
  overflow-y: auto;
  box-sizing: border-box;
`

export const StyledJSONEditor = styled.div`
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 1rem;
  margin-bottom: 1rem;
  overflow: auto;
`

export const StyledView = styled.div`
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 1rem;
  margin-bottom: 1rem;
  overflow: auto;
  padding: 1rem;
`

export const AreaLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #004099;
  padding: 0.5rem 2rem;
  height: 3rem;
`

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  h1 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: #fff;
  }
`

export const SaveButton = styled(Button)`
  width: 150px;

  button {
    background-color: transparent;
    border-color: #fff;
  }
`
